import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Download } from "lucide-react";

export const Route = createFileRoute("/_authenticated/membros/downloads")({
  head: () => ({ meta: [{ title: "Downloads — Projeto 101" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: DownloadsPage,
});

function DownloadsPage() {
  const { data } = useQuery({
    queryKey: ["downloads"],
    queryFn: async () => (await supabase.from("downloads").select("*").eq("active", true).order("sort_order")).data ?? [],
  });

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <div>
        <h1 className="font-display text-3xl font-extrabold">Downloads</h1>
        <p className="mt-1 text-sm text-[var(--gray-ink)]">
          Materiais complementares. Novos arquivos serão publicados aqui.
        </p>
      </div>
      <div className="space-y-3">
        {(data ?? []).map((d: any) => (
          <div key={d.id} className="flex items-start justify-between gap-4 rounded-2xl border border-black/5 bg-white p-5">
            <div>
              <h3 className="font-display text-lg font-extrabold">{d.title}</h3>
              <p className="mt-1 text-sm text-[var(--gray-ink)]">{d.description}</p>
            </div>
            <button
              disabled={!d.external_url && !d.file_path}
              className="inline-flex items-center gap-2 rounded-md bg-[var(--navy)] px-3 py-2 text-xs font-semibold text-white disabled:cursor-not-allowed disabled:opacity-40"
            >
              <Download size={14} /> Em breve
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
